import { FC } from 'react';
import './Fallback.scss';

const Fallback: FC = () => {
    return (
        <div className="fallback-container motif-row">
            <div className="fallback__content">
                <span>Something went wrong</span>
            </div>
        </div>
    );
};

export default Fallback;
